import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { simInfoColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getSimInfo } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "msisdn",
  "iccid",
  "status",
  "extra_data.message_route_id",
  "extra_data.message_enabled",
  "extra_data.voice_route_id",
  "extra_data.voice_enabled",
  "extra_data.forwarding_number",
  "extra_data.mms_message_enabled",
  "created_at",
  "last_updated",
];

const TmobilejSimInfoBatch = () => (
  <BatchDetail
    title="Sim Info"
    apiGet={__getSimInfo}
    client={CLIENTS.tmobilej}
    columnsFactory={(ctx) => simInfoColumns({ ...ctx, showTmobilejFields: true })}
    copyKeys={COPY_KEYS}
    exportAction="sim_info"
    showTerminate
    terminateOperation="sim_info"
  />
);

export default TmobilejSimInfoBatch;
